import { useEffect } from "react";
import Footer from "../Common/Footer";
import Header from "../Common/Header";

function About() {
    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
       <div className="page-wrapper">
    <Header />
<div className="content-wrapper">
    
    {/* About section start */}
  <section className="about-wrap style3 pt-100">
    <div className="container">
      <div className="row">
        <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div className="section-title style2 text-center mb-40">
            <h2>About Us</h2>
            <p>
             Simplifying and modernizing the real estate experience for India's fast-growing market
            </p>
          </div>
        </div>
      </div>
      <div className="about-img-wrap mb-30">
        <div className="row">
          <div className="col-12">
            <img src="assets/img/about/abbanner.jpg" alt="Image" />
          </div>
        
        </div>
      </div>
    </div>
  </section>
  {/* About section end */}

 {/* About section start */}
  <section className="about-wrap style2 pt-50 ">
    <div className="container">
      <div className="about-box">
        <img
          src="assets/img/about/about-shape-3.png"
          alt="Image"
          className="about-shape-three"
        />
        <div className="row gx-5 align-items-center">
        
          <div
            className="col-lg-6"
            data-aos="fade-left"
            data-aos-duration={1200}
            data-aos-delay={200}
          >
            <div className="about-content bgligtgreen">
              <div className="content-title style2">
                <div className="colorbox bg-teal mb-10">
                  <i class="ri-building-line"></i>
                </div>
                <h3>Our Story</h3>
                <p className="mb-10">
                 Founded in January 2026, we are a self-funded Indian startup built with a clear vision — to simplify and modernize the real estate experience for India's fast-growing market.
                </p>
                <p>We actively work with buyers, sellers, property owners, developers, and brokers to create a transparent, efficient, and technology-driven platform where real estate discovery and decision-making becomes easier, faster, and more reliable.

</p>
              </div>
           
            </div>
          </div>


            <div
            className="col-lg-6"
            data-aos="fade-right"
            data-aos-duration={1200}
            data-aos-delay={200}
          >
            <div className="imbx">
            <img src="assets/img/about/about1.jpg" alt="Image" />
            </div>
          </div>
        </div>
      </div>
    </div>


    
  </section>
  {/* About section end */}



    {/* About section start */}
  <section className="about-wrap style3 pt-100 mb-50">
    <div className="container">
      <div className="row">
        <div className="col-xl-12">
          <div className="cardd ">
          <div className="section-title style2 mb-40">
            <h3>What We Do</h3>
            <p className="fontbig">Our platform enables users to search, list, and explore properties across residential, commercial, rental, and new project categories — all in one place. We focus on building practical solutions that solve real on-ground challenges faced by Indian real estate consumers.

</p>

<p className="fontbig">Being a startup, our strength lies in agility, innovation, and customer-first thinking. We are continuously improving our technology, user experience, and data accuracy to deliver meaningful value rather than noise.

</p>
          </div>
          </div>
        </div>
      </div>
    
    </div>
  </section>
  {/* About section end */}


    {/* How It works section start*/}
  <section className="hw-wrap pt-50 pb-75">
    <div className="container">
      <div className="row">
        <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div className="section-title style2 text-center mb-40">
            <h2>Why Choose Us?</h2>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
          <div className="hw-card card">
           
                <div className="colorbox bg-orange mb-10">
                 <i class="ri-flag-line"></i>
                </div>
            <div className="hw-info">
              <h3>Built for India</h3>
              <p>Keeping local needs and behaviors at the core of everything we build</p>
            </div>
          </div>
        </div>

           <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
          <div className="hw-card card">
           
                <div className="colorbox bg-sky mb-10">
                  <i class="ri-rocket-line"></i>
                </div>
            <div className="hw-info">
              <h3>Startup Mindset</h3>
              <p>Fast, focused, and constantly evolving to meet your needs</p>
            </div>
          </div>
        </div>

           <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
          <div className="hw-card card">
           
                <div className="colorbox bg-purple mb-10">
                 <i class="ri-lightbulb-line"></i>
                </div>
            <div className="hw-info">
              <h3>Solution-Driven</h3>
              <p>Practical features that actually help users make better decisions</p>
            </div>
          </div>
        </div>

           <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
          <div className="hw-card card">
           
                <div className="colorbox bg-grey mb-10">
                 <i class="ri-search-eye-line"></i>
                </div>
            <div className="hw-info">
              <h3>Transparency & Trust</h3>
              <p>Clear information, no unnecessary clutter or hidden details</p>
            </div>
          </div>
        </div>

           <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
          <div className="hw-card card">
           
                <div className="colorbox bg-green mb-10">
                  <i class="ri-hand-coin-line"></i>
                </div>
            <div className="hw-info">
              <h3>Self-Funded</h3>
              <p>Driven by vision, not external pressure or investor demands</p>
            </div>
          </div>
        </div>

           <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
          <div className="hw-card card">
           
                <div className="colorbox bg-red mb-10">
                <i class="ri-heart-3-line"></i>
                </div>
            <div className="hw-info">
              <h3>Customer-First</h3>
              <p>Your needs and experience are at the heart of our platform</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* How It works section end*/}

  
    {/* About section start */}
  <section className="about-wrap style3 mb-50">
    <div className="container">
    
      <div className="about-img-wrap mb-30">
        <div className="row">
          <div className="col-12">
            <img src="assets/img/about/about2.jpg" alt="Image" />
          </div>
        
        </div>
      </div>
    </div>
  </section>
  {/* About section end */}

  {/* About section start */}
  <section className="about-wrap style3 mb-50">
    <div className="container">
      <div className="row">
        <div className="col-xl-12">
          <div className="skybox bg-skyblue">
          <div className="section-title style2 text-center">
            <h3>Our Commitment</h3>
            <p className="fontbig mb-20">Our platform enables users to search, list, and explore properties We believe real estate decisions should be informed, simple, and stress-free. Our journey has just begun, and we are committed to growing responsibly while delivering the best possible solutions for India's real estate ecosystem.

</p>
<h5 className="mb-0">We're building for today — and scaling for tomorrow.</h5>
          </div>
          </div>
        </div>
      </div>
    
    </div>
  </section>
  {/* About section end */}


    
    {/* About section start */}
  <section className="about-wrap style3 pt-50 pb-100">
    <div className="container">
      <div className="row">
        <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div className="section-title style2 text-center mb-40">
            <h2>Ready to Get Started?</h2>
            <p className="fontbig mb-30">Join thousands of users who trust us for their real estate needs
 </p>

   <div className="header-btn">
                    <button
                     type="button"
                     className="btn bg-teal-button"
                     style={{ marginRight: 10 }}>
                    Explore Properties
                   </button>
                    <button
                       type="button"
                        className="btn bg-teal-border-button" >
                       List Your Property
                     </button>

                  
 
                 </div>

          </div>
        </div>
      </div>
    
    </div>
  </section>
  {/* About section end */}

  </div>
    <Footer />
    </div>
    </>
  );
}

export default About;
